<template>
    <div id="payment-area">
        <div v-if="errorMessage">{{ this.errorMessage }}</div>
        <subscription v-model="dropinPayload" :token="token"></subscription>
        <a @click="doit()" class="btn btn-success" style="margin-top: 15px" :disabled="!submitReady">
            <span v-if="loading"><i class="icon icon-cog fa-spin"></i> creating subscription...</span>
            <span v-else>Start Premium Subscription</span>
        </a>
    </div>
</template>

<script>
    export default {
        name: "create-subscription",
        components: {
            'subscription': require('./subscription/payment.vue').default,
        },
        props: {
            token: { default: '' },
        },
        data() {
            return {
                loading: false,
                submitReady: false,
                dropinPayload: false,
                errorMessage: false,
            }
        },
        watch: {
            'dropinPayload': function () {
                this.submitReady = true;
            },
        },
        methods: {
            doit() {
                this.dropinPayload.requestPaymentMethod((dropinPayloadErr, dropinPayload) => {
                    if (dropinPayloadErr) {
                        this.errorMessage = 'There was an error with Drop-In Payload! Message: ' + dropinPayloadErr.message;
                        return;
                    }
                    this.nonce = dropinPayload.nonce;
                    this.submit();
                });
            },
            submit(){
                this.loading = true;
                this.submitReady = false;
                this.axios.post('/api/subscription/premium', {
                    nonce: this.nonce
                }).then((response) => {
                    myAlert({
                        success: response.data.success,
                        callback: () => {
                            window.location.reload(false);
                        }
                    });
                }).catch(error => {
                    this.errorMessage = 'There was an error subscribing to the premium plan. Please contact us.';
                    console.log(error);
                });
            }
        }
    }
</script>

<style scoped>
    #payment-area {
        width: 500px;
    }
    .btn {
        margin: 15px auto 0;
        display: block;
        width: 200px;
    }
</style>